import { Provider } from '@angular/core';

import { MailingApiService } from './mailing-api.service';
import { MailingHttpService } from './mailing-http.service';

/**
 * Registra la implementación de `MailingApiService` que usa la app.
 *
 * Los componentes piden la clase abstracta y nunca la concreta, así que
 * sustituir el cliente —por otra base de URL, por un decorador con caché— es
 * cambiar esta línea y nada más. Misma forma que `provideItTickets()`.
 */
export function provideMailing(): Provider[] {
  return [{ provide: MailingApiService, useClass: MailingHttpService }];
}
